import image1 from "../assets/michael.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";


export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the FitClub and by choosing the right plan and program I already achieved my ideal body!",
    name: "MATHEW DOW",
    status: "ENTREPRENEUR",
  },
  {
    image: image2,
    review:
      'Highly recommend "The fit club"  for their personalized workouts, expertise, and positive encouragement.',
    name: "JOHN KEVIN",
    status: "COACH",
  },
  {
    image: image3,
    review:
      "Experiencing tremendous progress with trainers. Their customized sessions, expertise, and motivating atmosphere ensure a fulfilling fitness journey!",
    name: "FRANKLIN",
    status: "CUSTOMER",
  },
];
